import { useSelector, useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  setShowOrderModal,
  setShowServiceModal,
} from "../redux-state/features/orderState";
import { clearCredentials } from "../redux-state/features/user/userSlice";
import { useNavigate } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBellConcierge,
  faDoorOpen,
  faPenToSquare,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
const UserNaveBar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userName, isAuthenticated, uuid } = useSelector(
    (state) => state.userState
  );
  useEffect(() => {
    if (!isAuthenticated) navigate("/");
  }, [isAuthenticated]);
  const logOut = () => {
    dispatch(clearCredentials());
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };
  return (
    <nav className="navbar navbar-expand-lg border-bottom border-body">
      <div className="container-fluid">
        <a className="navbar-brand text-dark" href="#"></a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle text-dark"
                href="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <FontAwesomeIcon className="mx-2" icon={faPlus} />
                إنشاء طلب جديد
              </a>
              <ul className="dropdown-menu">
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    style={{ fontSize: "12px" }}
                    onClick={() => dispatch(setShowServiceModal(true))}
                  >
                    <FontAwesomeIcon
                      className="mx-2"
                      icon={faBellConcierge}
                      size="lg"
                    />
                    <span style={{ fontSize: "10px" }}>طلب خدمة</span>
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider mb-1 mt-1" />
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    href="#"
                    style={{ fontSize: "12px" }}
                    onClick={() => dispatch(setShowOrderModal())}
                  >
                    {" "}
                    <FontAwesomeIcon
                      className="mx-2"
                      icon={faPenToSquare}
                      size="lg"
                    />
                    <span style={{ fontSize: "10px" }}> طلب مواد</span>
                  </a>
                </li>
                {/* <li>
                  <hr className="dropdown-divider" />
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Something else here
                  </a>
                </li> */}
              </ul>
            </li>
          </ul>
          <div className="d-flex align-items-center">
            <p className="text-dark  m-0">
              مرحبا بك : &nbsp;&nbsp;
              <strong className="text-success">{userName}</strong>
            </p>
            <span class="vertical-rule"></span>
            <a href="#" className="nav-link text-muted  " onClick={logOut}>
              <FontAwesomeIcon className="mx-3" icon={faDoorOpen} size="lg" />
              تسجيل الخروج
            </a>
          </div>
          {/* <form className="d-flex" role="search">
            <input
              className="form-control me-2"
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
            <button className="btn btn-outline-success" type="submit">
              Search
            </button>
          </form> */}
        </div>
      </div>
    </nav>
  );
};
export default UserNaveBar;
